import { IconProp } from '@fortawesome/fontawesome-svg-core';

export const getBreadcrumbStatus = (id: string) => {
  return id && id !== 'new' ? 'edit' : 'new';
};

export type LastBreadcrumbStatus = 'new' | 'edit' | 'view';

export type LastBreadcrumb = {
  icon: IconProp;
  label: string;
};

export const getLastBreadcrumb = (
  status: LastBreadcrumbStatus | undefined,
  viewTitle: string
): LastBreadcrumb | undefined => {
  if (status === 'edit') return { icon: 'pencil-alt', label: 'Edição' };
  if (status === 'new') return { icon: 'plus', label: 'Novo' };
  if (status === 'view') return { icon: 'eye', label: viewTitle };
  return undefined;
};

export const isIFrame = (search: string): boolean => {
  return /iframe=true/.test(search);
};

export const isFormNew = (id: string): boolean => {
  return getBreadcrumbStatus(id) === 'new';
};
